import airPods from "../images/AirPods.png";
import iphone from "../images/case.png";
import ipad from "../images/ipad.png";
import iwatch from "../images/iwatch.png";

interface Category {
  id: number;
  img: string;
  text: string;
}

const categoryData: Category[] = [
  { id: 1, img: ipad, text: "IPAD" },
  { id: 2, img: iphone, text: "IPHONE" },
  { id: 3, img: iwatch, text: "APPLE WATCH" },
  { id: 4, img: airPods, text: "ACCESSORIES" },
];

export default categoryData;
